module.exports = require('./helpers/bundle-url').getBundleURL('kvOFJ') + "light-mode.9ae6186d.svg";